import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import ActiveApplications from "../../core/config/activeApplications";
import { ajaxCall } from "../../core/services/ajaxService";

const applicationsConfig = ActiveApplications;

interface GridProps {
  alias: string;
}

const ApplicationsDataGrid = (props: GridProps) => {
  const [data, setData] = useState([]);
  const configData: any = applicationsConfig.find(
    (x) => x.alias == props.alias
  );
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);

  const fetchData = () => {
    ajaxCall(`${configData.url}api/Data/getData`, {}).then((res) => {
      if (res.length > 0) {
        setColumns(getColumns(res));
        setRows(getRows(res));
      }
    });
  };

  useEffect(() => {
    // configData = applicationsConfig.find(x => x.alias == props.alias);
    console.log(configData);

    fetchData();
  }, []);

  const getColumns = (data: any) => {
    let dataToSetColumnsFrom = data[0];
    let columns: any = [];
    Object.keys(dataToSetColumnsFrom).forEach((key) => {
      if (key == "questionsJSON" || configData.removedColumns.includes(key)) {
        return;
      }
      if (key == "questions") {
        Object.entries(dataToSetColumnsFrom.questions).forEach((entry: any) => {
          columns.push({
            field: entry[1].question,
            headerName: entry[1].question,
            sortable: true,
            editable: false,
            width: 150,
          });
        });
      } else
        columns.push({
          field: key,
          headerName: key,
          sortable: true,
          editable: false,
          width: 120,
        });
    });
    return columns;
  };

  const getRows = (data: any) => {
    let rows: any = [];
    let idCounter = 0;
    for (const item of data) {
      let row: { [k: string]: any } = {};
      row.id = idCounter++;
      // idCounter=idCounter++
      Object.entries(item).forEach((entry) => {
        if (
          entry[0] == "questionsJSON" ||
          configData.removedColumns.includes(entry[0])
        ) {
          return;
        }
        if (entry[0] == "questions") {
          Object.entries(item.questions).forEach((questionEntry: any) => {
            row[questionEntry[1].question] = questionEntry[1].answer;
          });
        } else {
          if (entry[0] == "doe") {
            let entryDate: any = entry[1];
            row["doe"] = new Date(entryDate).toLocaleDateString("bg");
          } else {
            row[entry[0]] = entry[1];
          }
        }
      });
      rows.push(row);
    }
    return rows;
  };

  return (
    <div style={{ height: 800, width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        // pageSize={20}
        // rowsPerPageOptions={[10]}
      />
    </div>
  );
};

export default ApplicationsDataGrid;
